import React from 'react'

function Experience() {
    return (
        <>
        <div className="experience-text-area">
        <div className="container text-center mb-5">
         <h4 className="text-center mb-5" >  Currently I don't have any professional experience,  </h4>
         <h5 className="text-center mb-5" >    meanwhile you can check my progress on  </h5>
         <h5 className="text-center mb-5" >     the tab of navigation Projects </h5>
         <h3 className="text-center mb-5" >  Coming soon  </h3>
         <h4 className="text-center" >  Meanwhile check my social networks  </h4>
         </div>
         </div>

        </>
       
    )
}

export default Experience
